import React from 'react';

import {
  ClientJourneyWeeks,
  MessageSendDays,
} from '../../../../Model/CoachConfig';
import ClientJourneyBroadcastMessaging from '../ClientJourneyBroadcastMessaging';

const clientJourneyWeekOption = Object.entries(ClientJourneyWeeks).map(([key, value]) => ({
  value,
  label: `Week ${value}`,
  key,
}));

const messageSendDayOption = Object.entries(MessageSendDays).map(([key, value]) => ({
  value,
  label: `Day ${value}`,
  key,
}));

const WeeklyMessage = () => (
  <ClientJourneyBroadcastMessaging
    cohortOptions={clientJourneyWeekOption}
    dayOptions={messageSendDayOption}
  />
);

export default WeeklyMessage;
